export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const PERSONAL_EMAIL_DOMAINS = new Set([
  'gmail.com',
  'googlemail.com',
  'yahoo.com',
  'ymail.com',
  'outlook.com',
  'hotmail.com',
  'live.com',
  'msn.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'aol.com',
  'protonmail.com',
  'proton.me',
  'rediff.com',
  'rediffmail.com',
  'yopmail.com',
  'gmx.com',
  'mail.com',
]);

const PERSONAL_EMAIL_ROOTS = new Set([
  'gmail',
  'googlemail',
  'yahoo',
  'ymail',
  'outlook',
  'hotmail',
  'live',
  'icloud',
  'aol',
  'protonmail',
  'yopmail',
  'rediffmail',
]);

export const isPersonalEmail = (value) => {
  const domain = value.split('@')[1]?.toLowerCase().trim();
  if (!domain) return true;
  if (PERSONAL_EMAIL_DOMAINS.has(domain)) return true;
  return PERSONAL_EMAIL_ROOTS.has(domain.split('.')[0]);
};
